import { render, staticRenderFns } from "./VolvoDisclosure2023.vue?vue&type=template&id=c2ca9fd6&"
import script from "./VolvoDisclosure2023.vue?vue&type=script&lang=js&"
export * from "./VolvoDisclosure2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports